import React from "react";
import { graphql, useFragment } from "react-relay";
import { ListItem } from "./ListItem";
import { ListItemTeamSelect_team$key } from "./__generated__/ListItemTeamSelect_team.graphql";

export function ListItemTeamSelect(props: {
  team: ListItemTeamSelect_team$key;
  selected: boolean;
  isFirst?: boolean;
  isLast?: boolean;
  onPress?: () => void;
}) {
  const team = useFragment(
    graphql`
      fragment ListItemTeamSelect_team on Team {
        name
        ...ListItemTeamIndicator_team
      }
    `,
    props.team
  );

  return (
    <ListItem
      isFirst={props.isFirst}
      isLast={props.isLast}
      onPress={props.onPress}
      left={<ListItem.TeamIndicator team={team} />}
      right={<ListItem.SelectIndicator selected={props.selected} />}
    >
      <ListItem.Title>{team.name}</ListItem.Title>
    </ListItem>
  );
}
